import { Brand } from "../types/brand";
import { create } from "zustand";


type BrandState = {
  brands: Brand[];
  brandIndustries: string[];
}

type BrandActions = {
  setBrands: (brands: Brand[]) => void,
  setBrandIndustries: (industries: string[]) => void;
  addNewBrand: (brand: Brand) => void;
  updateBrand: (brandId: string, updates: Partial<Brand>) => void;
}

const initialState: BrandState = {
  brands: [],
  brandIndustries: [],
}

export const useBrandStore = create<BrandState & BrandActions>((set) => ({

  ...initialState,

  setBrands: (b) => set((state) => ({
    ...state,
    brands: [...b]
  })),

  setBrandIndustries: (ind) => set((state) => ({
    ...state,
    brandIndustries: [...ind]
  })),

  addNewBrand: (brand) => set((state) => {
    const normalizedBrand: Brand = {
      ...brand,
      children: brand.children || []
    };

    if (!normalizedBrand.parent_brand_id) {
      return {
        ...state,
        brands: [...state.brands, normalizedBrand]
      }
    }

    const addBrandToParent = (brands: Brand[]): Brand[] => {
      return brands.map(b => {
        if (b.id === normalizedBrand.parent_brand_id) {
          return {
            ...b,
            has_child_brands: true,
            children: [...(b.children || []), normalizedBrand]
          };
        }
        // Recursively check children
        if (b.children?.length) {
          return {
            ...b,
            children: addBrandToParent(b.children)
          };
        }
        return b;
      });
    };

    return {
      ...state,
      brands: addBrandToParent(state.brands)
    }
  }),

  updateBrand: (brandId, updates) => set((state) => {
    const updateBrandInTree = (brands: Brand[]): Brand[] => {
      return brands.map(b => {
        if (b.id === brandId) {
          return {
            ...b,
            ...updates,
            children: b.children || []
          };
        }
        if (b.children?.length) {
          return {
            ...b,
            children: updateBrandInTree(b.children)
          };
        }
        return b;
      });
    };

    return {
      ...state,
      brands: updateBrandInTree(state.brands)
    };
  }),

}));